module.exports = __webpack_public_path__ + "img/trophy.2a78699e.svg";